module.exports = __webpack_public_path__ + "img/電気回路_3_9_3.852b9259.png";